import { isEmpty } from "lodash";
import Flx from "../../components/layout/Flx";
import RenderedPreviewBorrowerItems from "./components/renderers/RenderedPreviewBorrowerItems";
import RenderedPreviewExistingFileItems from "./components/renderers/RenderedPreviewExistingFileItems";
import RenderedPreviewPropertyItems from "./components/renderers/RenderedPreviewPropertyItems";

const EnhancedCommentAttachmentPreview = ({
  loan,
  //
  loanDocumentIds,
  borrowerIds,
  subjectPropertyIds,

  disableDelete,
  uploadedFiles,
  onDeleteAttachment,

  sx,
  children,
}) => {
  const hasAttachments =
    !isEmpty(loanDocumentIds) ||
    !isEmpty(borrowerIds) ||
    !isEmpty(subjectPropertyIds) ||
    !isEmpty(uploadedFiles);

  if (!hasAttachments) {
    return null;
  }

  return (
    <Flx wrap gap={1} sx={{ py: 1, ...sx }}>
      {children}
      <RenderedPreviewExistingFileItems
        loan={loan}
        ids={loanDocumentIds}
        name="loanDocuments"
        disableDelete={disableDelete}
        onDelete={
          disableDelete ? null : (id) => onDeleteAttachment(id, "loanDocuments")
        }
      />
      <RenderedPreviewBorrowerItems
        loan={loan}
        ids={borrowerIds}
        name="borrowers"
        disableDelete={disableDelete}
        onDelete={
          disableDelete ? null : (id) => onDeleteAttachment(id, "borrowers")
        }
      />
      <RenderedPreviewPropertyItems
        loan={loan}
        ids={subjectPropertyIds}
        name="subjectProperties"
        disabled={disableDelete}
        onDelete={
          disableDelete
            ? null
            : (id) => onDeleteAttachment(id, "subjectProperties")
        }
      />
    </Flx>
  );
};

export default EnhancedCommentAttachmentPreview;
